import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import SalesMaintenance from "../SalesMaintenance";
import { Accordion, Spinner, Modal } from "react-bootstrap";
import errorMessages from "../../common/errorMessages";
import { Select } from "antd";
import { Steps, Button } from "antd";
import DatePicker from "react-datepicker";
import {
  fetchCountyList,
  fetchLegalEntityList,
  fetchWholesalerLevelList,
  fetchMarketAuthorizationList,
  fetchFormList,
  fetchFormulationList,
  fetchPackagingList,
  fetchTargetPeriod,
  fetchMaintenanceList,
  getDailySelloutCAReportList,
  fetchHundredBedsList,
  fetchTwoHundredBedsList,
  fetchEvaluationTargetClassificationList,
  fetchProductsList,
  fetchSalesPrefectureList,
  fetchWholesalerGroupList,
} from "./actions";
import { LOAD_MORE_PAGE_SIZE } from "../../constants/pagination";

function DailySelloutCA() {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [show, setShow] = useState(false);
  const [allSelected, setAllSelected] = useState(0);
  const [preliminaryReport, setPreliminaryReport] = useState("1");
  const [previousBusinessDay, setPreviousBusinessDay] = useState("0");
  const [showUserMessage, setShowUserMessage] = useState(false);
  const [showDownloadMessage, setShowDownloadMessage] = useState(false);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState("");
  const [targetPeriod, setTargetPeriod] = useState("0");
  const [processingDate, setProcessingDate] = useState("");
  const [personInCharge, setPersonInCharge] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [duration, setDuration] = useState("preliminaryReport");
  const [productId, setProductId] = useState("");
  const [approvalId, setApprovalId] = useState("");
  const [dosageId, setDosageId] = useState("");
  const [standardId, setStandardId] = useState("");
  const [packagingId, setPackagingId] = useState("");
  const [wholesalerGroupId, setWholesalerGroupId] = useState("");
  const [prefectureId, setPrefectureId] = useState("");
  const [countyId, setCountyId] = useState("");
  const [productStatus, setProductStatus] = useState();
  const [copromotionStatus, setCopromotionStatus] = useState(false);
  const [hundredFloorId, setHundredFloorId] = useState("");
  const [twoHundredFloorId, setTwoHundredFloorId] = useState("");
  const [evaluationTargetId, setEvaluationTargetId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDateDisplay, setFromDateDisplay] = useState("");
  const [toDateDisplay, setToDateDisplay] = useState("");
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(LOAD_MORE_PAGE_SIZE);
  const [role, setRole] = useState("");
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [marketLoading, setMarketLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [formulationLoading, setFormulationLoading] = useState(false);
  const [packLoading, setPackLoading] = useState(false);
  const [legalEntityLoading, setLegalEntityLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(true);

  const [sortDistrictName, setSortDistrictName] = useState("asc");
  const [sortPerson, setSortPerson] = useState("asc");
  const [sortParentFacility, setSortParentFacility] = useState("asc");
  const [sortDeliveryFacility, setSortDeliveryFacility] = useState("asc");
  const [sortAccountingMonth, setSortAccountingMonth] = useState("asc");
  const [sortDueDate, setSortDueDate] = useState("asc");
  const [sortPack, setSortPack] = useState("asc");
  const [sortPackageQuantity, setSortPackageQuantity] = useState("asc");
  const [sortSalesAmount, setSortSalesAmount] = useState("asc");
  const [sortSalesAmountByWholesaler, setSortSalesAmountByWholesaler] =
    useState("asc");
  const [sortSalesAmountByCustomer, setSortSalesAmountByCustomer] =
    useState("asc");
  const [sortCustomerPurchasePrice, setSortCustomerPurchasePrice] =
    useState("asc");
  const [sortWholesaleCorporation, setSortWholesaleCorporation] =
    useState("asc");
  const [sortWholesaleBranch, setSortWholesaleBranch] = useState("asc");
  const [sortSlipNumber, setSortSlipNumber] = useState("asc");
  const [sortTransactionClassification, setSortTransactionClassification] =
    useState("asc");
  const [sortHundredBeds, setSortHundredBeds] = useState("asc");
  const [sortEvaluationTarget, setSortEvaluationTarget] = useState("asc");
  const [loginName, setLoginName] = useState("");
  const [maintenance, setMaintenance] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const [productsList, setProductsList] = useState([]);
  const [marketAuthList, setMarketAuthList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [formulationList, setFormulationList] = useState([]);
  const [packagingList, setPackagingList] = useState([]);
  const [hundredBedsList, setHundredBedsList] = useState([]);
  const [twoHundredBedsList, setTwoHundredBedsList] = useState([]);
  const [
    evaluationTargetClassificationList,
    setEvaluationTargetClassificationList,
  ] = useState([]);
  const [prefectureList, setPrefectureList] = useState([]);
  const [countyList, setCountyList] = useState([]);
  const [wholesalerGroupList, setWholesalerGroupList] = useState([]);
  const [legalEntityList, setLegalEntityList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedMarketAuth, setSelectedMarketAuth] = useState([]);
  const [selectedForm, setSelectedForm] = useState([]);
  const [selectedFormulation, setSelectedFormulation] = useState([]);
  const [selectedPackaging, setSelectedPackaging] = useState([]);
  const [selectedWholesaler, setSelectedWholesaler] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [selectedPrefecture, setSelectedPrefecture] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState([]);
  const [reportListing, setReportListing] = useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("SalesMenu.dailySelloutCA")}`,
      path: "/dailySelloutReportCA",
    },
  ];

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const details = useSelector((state) => state.salesReport.dailySelloutCA);
  var personName;
  if (sessionStorage.getItem("User role") === "MR") {
    personName = sessionStorage.getItem("Kanji name");
  } else {
    personName = "";
  }
  if (details.length > 1) {
    personName = "複数選択";
  } else if (details.length === 0) {
    if (sessionStorage.getItem("User role") === "MR") {
      personName = sessionStorage.getItem("Kanji name");
    } else {
      personName = "";
    }
  } else if (details.length === 1) {
    if (details[0].role_code === "5003") {
      personName = details[0].name_kanji;
    } else personName = "";
  }

  const current = new Date();
  const startDate = new Date(current.getFullYear() - 5, current.getMonth() - 1, 1);
  const endDate = new Date(current.getFullYear(), current.getMonth() + 1, 0);

  useEffect(() => {
    document.body.classList.add("sidebar-open");
    const productList = sessionStorage.getItem("Product");
    const marketAuthList = sessionStorage.getItem("Market Auth List");
    const formList = sessionStorage.getItem("Form");
    const formulationList = sessionStorage.getItem("Formulation");
    const packList = sessionStorage.getItem("Pack");
    const hundredBeds = sessionStorage.getItem("Hundred beds sales");
    const twoHundredBeds = sessionStorage.getItem("Two hundred beds sales");
    const salesPrefectureList = sessionStorage.getItem("Sales prefecture");
    const countyList = sessionStorage.getItem("County");
    const wholesalerGroupList = sessionStorage.getItem("Wholesaler group list");
    const evaluationList = sessionStorage.getItem(
      "Evaluation target classification"
    );
    
    const role = sessionStorage.getItem("User role");
    setRole(role);
    const token = sessionStorage.getItem("token");
    let name = sessionStorage.getItem("Kanji name");
    sessionStorage.setItem("return_url", "/dailySelloutReportCA");
    !sessionStorage.getItem("Hundred beds sales") && getHundredBedsList();
    !sessionStorage.getItem("Two hundred beds sales") &&
      getTwoHundredBedsList();
    !sessionStorage.getItem("Evaluation target classification") &&
      getEvaluationTargetClassificationList();
    !sessionStorage.getItem("Sales prefecture") && getSalesPrefectureList();
    !sessionStorage.getItem("Wholesaler group list") &&
      getWholesalerGroupList();
    setLoginName(name);
    setProductsList(JSON.parse(productList));
    setMarketAuthList(JSON.parse(marketAuthList));
    setFormList(JSON.parse(formList));
    setFormulationList(JSON.parse(formulationList));
    setPackagingList(JSON.parse(packList));
    hundredBeds && setHundredBedsList(JSON.parse(hundredBeds));
    twoHundredBeds && setTwoHundredBedsList(JSON.parse(twoHundredBeds));
    hundredBeds &&
      JSON.parse(hundredBeds)[0] &&
      setHundredFloorId(JSON.parse(hundredBeds)[0].value);
    twoHundredBeds &&
      JSON.parse(twoHundredBeds)[0] &&
      setTwoHundredFloorId(JSON.parse(twoHundredBeds)[0].value);
    evaluationList &&
      JSON.parse(evaluationList)[0] &&
      setEvaluationTargetId(JSON.parse(evaluationList)[0].value);
    setPrefectureList(JSON.parse(salesPrefectureList));
    setCountyList(JSON.parse(countyList));
    setWholesalerGroupList(JSON.parse(wholesalerGroupList));
    evaluationList &&
      setEvaluationTargetClassificationList(JSON.parse(evaluationList));
    setPersonInCharge(sessionStorage.getItem("WWID"));
    setOrganizationName(sessionStorage.getItem("Organization name"));
    !sessionStorage.getItem("Product") && getProductList();
    !sessionStorage.getItem("Market Auth List") && getMarketAuthorizationList();
    !sessionStorage.getItem("Form") && getFormList();
    !sessionStorage.getItem("Formulation") && getFormulationList();
    !sessionStorage.getItem("Pack") && getPackList();
    !sessionStorage.getItem("Hundred beds sales") && getHundredBedsList();
    !sessionStorage.getItem("Two hundred beds sales") &&
      getTwoHundredBedsList();
    !sessionStorage.getItem("Evaluation target classification") &&
      getEvaluationTargetClassificationList();
    token && getTargetPeriod();
    getMaintenanceTime();
  }, []);

  /*** 
  @purpose : Get product list
  @Parameter : {}
  **/
  const getProductList = async () => {
    await fetchProductsList().then((res) => {
      let newList = [];
      if (res && res.length > 0) {
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.prdctlvl_cd,
            label: item.prdctlvl_sym,
          });
        }
        setProductsList(newList);
        sessionStorage.setItem("Product", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get market auth list
  @Parameter : {}
  **/
  const getMarketAuthorizationList = async () => {
    let body = {
      prdctlvl_cd: "ALL",
    };
    await fetchMarketAuthorizationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
        sessionStorage.setItem("Market Auth List", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get form list
  @Parameter : {}
  **/
  const getFormList = async () => {
    let body = {
      aprlvl_cd: "ALL",
      // "market_authorization": "ALL"
    };
    await fetchFormList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
        sessionStorage.setItem("Form", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get formulation list
  @Parameter : {}
  **/
  const getFormulationList = async () => {
    let body = {
      frmlvl_cd: "ALL",
      // "market_authorization": "ALL",
      // "form_codes": "ALL"
    };
    await fetchFormulationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
        sessionStorage.setItem("Formulation", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get pack list
  @Parameter : {}
  **/
  const getPackList = async () => {
    let body = {
      stdlvl_cd: "ALL",
    };
    await fetchPackagingList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
        sessionStorage.setItem("Pack", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get two hundred beds sales list
  @Parameter : {}
  **/
  const getSalesPrefectureList = async () => {
    await fetchSalesPrefectureList().then((res) => {
      const newList = Array.isArray(res)
      ? res.map((item) => ({
          value: item.state_province_code,
          label: item.state_province_name_local,
        }))
      : [];
      setPrefectureList(newList);
      sessionStorage.setItem("Sales prefecture", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesalerGroupList = async () => {
    await fetchWholesalerGroupList().then((response) => {
      if (response.data.success == true && response.data.data) {
        let newList = [];
        for (let index = 0; index < response.data.data.length; index++) {
          const item = response.data.data[index];
          newList.push({
            value: item.wholesaler_organization_code_jp,
            label: item.wholesaler_organization_name,
          });
        }
        setWholesalerGroupList(newList)
        sessionStorage.setItem(
          "Wholesaler group list",
          JSON.stringify(newList)
        );
      }
    });
  };

  /*** 
  @purpose : Get hundred beds sales list
  @Parameter : {}
  **/
  const getHundredBedsList = async () => {
    await fetchHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setHundredFloorId(newList[0].value);
      setHundredBedsList(newList);
      sessionStorage.setItem("Hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get two hundred beds sales list
  @Parameter : {}
  **/
  const getTwoHundredBedsList = async () => {
    await fetchTwoHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setTwoHundredFloorId(newList[0].value);
      setTwoHundredBedsList(newList);
      sessionStorage.setItem("Two hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get evaluation target classification
  @Parameter : {}
  **/
  const getEvaluationTargetClassificationList = async () => {
    await fetchEvaluationTargetClassificationList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setEvaluationTargetId(newList[0].value);
      setEvaluationTargetClassificationList(newList);
      sessionStorage.setItem(
        "Evaluation target classification",
        JSON.stringify(newList)
      );
    });
  };

  /*** 
    @purpose : Get maintenance time period
    @Parameter : {}
    **/
  const getMaintenanceTime = async () => {
    let body = {
      userType: "ALL",
      report_type: "daily-sellout",
    };
    await fetchMaintenanceList(body).then((response) => {
      setIsScreenLoading(false);
      setMaintenance(response && response.data && response.data.odsFlag);
    });
  };

  /*** 
    @purpose : Close modal
    @Parameter : {}
    **/
  const handleClose = () => setShow(false);

  /*** 
    @purpose : Show modal
    @Parameter : {}
    **/
  const modalShow = (value) => {
    setShow(true);
  };

  /*** 
  @purpose : Close user modal
  @Parameter : {}
  **/
  const handleCloseUserMessage = () => setShowUserMessage(false);

  /*** 
  @purpose : Close download message modal
  @Parameter : {}
  **/
  const handleCloseDownloadMessage = () => setShowDownloadMessage(false);

  /*** 
    @purpose : Change route
    @Parameter : {e, page}
    **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page, {
      state: { page: "dailySelloutCA" },
    });
  };

  /*** 
    @purpose : Get target period
    @Parameter : {}
    **/
  const getTargetPeriod = async () => {
    sessionStorage.setItem("return_url", "");
    await fetchTargetPeriod("dailySelloutCA").then((response) => {
      setFromDate(
        response && response.from_date
          ? response.from_date.split("/").join("")
          : ""
      );
      setToDate(
        response && response.to_date ? response.to_date.split("/").join("") : ""
      );
      setFromDateDisplay(
        response && response.from_date ? response.from_date : ""
      );
      setToDateDisplay(response && response.to_date ? response.to_date : "");
      setProcessingDate(
        response && response.processing_date ? response.processing_date.split(" ")[0] : ""
      );
    });
  };

  const handleAllSelected = (e) => {
    setAllSelected(e.target.checked ? 1 : 0);
  };

  const handleDuration = (e) => {
    if (e.target.value === "preliminaryReport") {
      setPreliminaryReport("1");
      setPreviousBusinessDay("0");
      setTargetPeriod("0");
    } else if (e.target.value === "previousBusinessDay") {
      setPreviousBusinessDay("1");
      setPreliminaryReport("0");
      setTargetPeriod("0");
    } else if (e.target.value === "targetPeriod") {
      setPreviousBusinessDay("0");
      setPreliminaryReport("0");
      setTargetPeriod("1");
    }
    setDuration(e.target.value);
  };

  const handleProductSelect = async (e) => {
    let list = [];
    list = [...selectedProducts, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        prdctlvl_cd: list1,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
      setSelectedProducts(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        prdctlvl_cd: list2,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
      setSelectedProducts(list2);
    }
  };

  const handleMarketAuthSelect = async (e) => {
    let list = [];
    list = [...selectedMarketAuth, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        aprlvl_cd: list1,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });

      setSelectedMarketAuth(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      let body = {
        aprlvl_cd: list2,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });

      setSelectedMarketAuth(list2);
    }
  };

  const handleFormSelect = async (e) => {
    let list = [];
    list = [...selectedForm, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        frmlvl_cd: list1,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });

      setSelectedForm(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        frmlvl_cd: list2,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });
      setSelectedForm(list2);
    }
  };

  const handleFormulationSelect = async (e) => {
    let list = [];
    list = [...selectedFormulation, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        stdlvl_cd: list1,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
      setSelectedFormulation(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        stdlvl_cd: list2,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
      setSelectedFormulation(list2);
    }
  };

  const handlePackSelect = (e, value) => {
    let list = [];
    list = [...selectedPackaging, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      setSelectedPackaging(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      setSelectedPackaging(list2);
    }
  };

  /*** 
  @purpose : Handle product change
  @Parameter : {value}
  **/
  const handleProductChange = async (value) => {
    setMarketLoading(true);
    if (value.length < selectedProducts.length && value.length > 0) {
      setSelectedProducts(value);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        prdctlvl_cd: value,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
    } else if (value.length === 0) {
      setMarketLoading(false);
      setSelectedProducts([]);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle market authorization change
  @Parameter : {value}
  **/
  const handleMarketAuthorizationChange = async (value) => {
    setFormLoading(true);
    if (value.length < selectedMarketAuth.length && value.length > 0) {
      setSelectedMarketAuth(value);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        aprlvl_cd: selectedProducts,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });
    } else if (value.length === 0) {
      setFormLoading(false);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle form change
  @Parameter : {value}
  **/
  const handleFormChange = async (value) => {
    setFormulationLoading(true);
    if (value.length < selectedForm.length && value.length > 0) {
      setSelectedForm(value);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        frmlvl_cd: selectedProducts,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });
    } else if (value.length === 0) {
      setFormulationLoading(false);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle formulation change
  @Parameter : {value}
  **/
  const handleFormulationChange = async (value) => {
    setPackLoading(true);
    if (value.length < selectedFormulation.length && value.length > 0) {
      setSelectedFormulation(value);
      setSelectedPackaging([]);
      let body = {
        stdlvl_cd: value,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
    } else if (value.length === 0) {
      setPackLoading(false);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle packaging change
  @Parameter : {value}
  **/
  const handlePackagingChange = (value) => {
    setSelectedPackaging(value);
  };

  const handleWholesalerGroupChange = async (value) => {
    if (value.length < selectedWholesaler.length && value.length > 0) {
      setSelectedWholesaler(value);
      setLegalEntityLoading(true);
      setSelectedEntity([]);
      let body = {
        whsl_grp_cd: value,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        if (response.data.length > 0) {
          setLegalEntityLoading(false);
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.whsl_crp_cd,
              label: item.whsl_crp_nm,
            });
          }
          setLegalEntityList(newList);
        }
      });
    } else if (value.length === 0) {
      setLegalEntityLoading(false);
      setSelectedWholesaler([]);
      setSelectedEntity([]);
    }
  };

  const handleWholeSalerGroupSelect = async (e) => {
    let list = [];
    list = [...selectedWholesaler, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        whsl_grp_cd: list1,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        if (response.data.length > 0) {
          setLegalEntityLoading(false);
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.whsl_crp_cd,
              label: item.whsl_crp_nm,
            });
          }
          setLegalEntityList(newList);
        }
      });
      setSelectedWholesaler(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        whsl_grp_cd: list2,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        if (response.data.length > 0) {
          setLegalEntityLoading(false);
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.whsl_crp_cd,
              label: item.whsl_crp_nm,
            });
          }
          setLegalEntityList(newList);
        }
      });
      setSelectedWholesaler(list2);
    }
  };

  const handleLegalEntityChange = (value) => {
    setSelectedEntity(value);
  };

  const handlePrefectureChange = async (value) => {
    if (value.length > 0) {
      setCityLoading(true);
      setSelectedPrefecture(value);
      let body = {
        prefecture_code: value,
      };
      await fetchCountyList(body).then((response) => {
        setCityLoading(false);
        let newList = [];
        if (Array.isArray(response.data)) {
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.county_code,
              label: item.county_name_local,
            });
          }
        } else {
          newList = [];
        }
        setCountyList(newList);
      });
    } else if (value.length === 0) {
      setCityLoading(false);
      setSelectedPrefecture([]);
      setSelectedCounty([]);
    }
  };

  const handleCountyChange = (value) => {
    setSelectedCounty(value);
  };

  const handleFromYear = (date) => {
    var fullDate = new Date(date),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var dt = [fullDate.getFullYear(), mnth, day].join("");
    var time = fullDate.toLocaleTimeString();
    setFromDate(dt);
    setFromDateDisplay([fullDate.getFullYear(), mnth, day].join("/"));
  };

  const handleToYear = (date) => {
    var fullDate = new Date(date),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var dt = [fullDate.getFullYear(), mnth, day].join("");
    var time = fullDate.toLocaleTimeString();
    setToDate(dt);
    setToDateDisplay([fullDate.getFullYear(), mnth, day].join("/"));
  };

  const handleProductStatus = (e) => {
    setProductStatus(e.target.checked);
    setSelectedProducts([]);
    setSelectedMarketAuth([]);
    setSelectedForm([]);
    setSelectedFormulation([]);
    setSelectedPackaging([]);
  };

  const handleCopromotionStatus = (e) => {
    setCopromotionStatus(e.target.checked);
  };

  const handleHundredFloorChange = (value) => {
    setHundredFloorId(value.value);
  };

  const handleTwoHundredFloorChange = (value) => {
    setTwoHundredFloorId(value.value);
  };

  const handleEvaluationTargetChange = (value) => {
    setEvaluationTargetId(value.value);
  };

  const getDailySelloutReportCA = () => {
    allSelected === 1 ? setShowUserMessage(true) : handleDailySelloutReportCA();
  };

  const handleDailySelloutReportCA = async () => {
    setLoading(true);
    setReportListing([]);
    setShowUserMessage(false);
    setNoData(false);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      target_date_from: targetPeriod === "0" ? "" : fromDate,
      target_date_to: targetPeriod === "0" ? "" : toDate,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      evaluation_target_classification: evaluationTargetId,
      preliminary_report: preliminaryReport,
      previous_business_day_only: previousBusinessDay,
      products_not_in_charge: productStatus,
      wholesaler_group:
        selectedWholesaler.length > 0 ? selectedWholesaler : "ALL",
      wholesaler_legal_entity:
        selectedEntity.length > 0 ? selectedEntity : "ALL",
      prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
      county: selectedCounty.length > 0 ? selectedCounty : "ALL",
      // company_copromotion_flg: copromotionStatus,
      userType: "CA",
      sort_field: "",
      sort_order: "",
      limit: LOAD_MORE_PAGE_SIZE
    };
    await getDailySelloutCAReportList(body).then((response) => {
      setReportListing(response && response.data.data);
      setTotal(response && response.data.total_count);
      if (response.success === true && response.data.data.length > 0) {
        setReportListing(response && response.data.data);
        let count = response.data.total_count.split(",");

        setTotal(parseInt(count.join("")));
        setLimit(LOAD_MORE_PAGE_SIZE * 2);
        setNoData(false);
        setLoading(false);
      } else if (
        (response.success === true && response.data.data.length === 0) ||
        response.success === false
      ) {
        setNoData(true);
        setLoading(false);
        setReportListing([]);
        setTotal();
      }
    });
  };

  const handleExcelDownload = async () => {
    setExcelLoading(true);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      target_date_from: targetPeriod === "0" ? "" : fromDate,
      target_date_to: targetPeriod === "0" ? "" : toDate,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      evaluation_target_classification: evaluationTargetId,
      preliminary_report: preliminaryReport,
      previous_business_day_only: previousBusinessDay,
      products_not_in_charge: productStatus,
      wholesaler_group:
        selectedWholesaler.length > 0 ? selectedWholesaler : "ALL",
      wholesaler_legal_entity:
        selectedEntity.length > 0 ? selectedEntity : "ALL",
      prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
      county: selectedCounty.length > 0 ? selectedCounty : "ALL",
      // company_copromotion_flg: copromotionStatus,
      userType: "CA",
      view_type: "download",
      sort_field: sortField,
      sort_order: sortOrder,
      batch_size: 10000,
    };
    await getDailySelloutCAReportList(body).then((response) => {
      setExcelLoading(false);
      if (Object.keys(response).includes("file")) {
        // window.location.href = response.file
        var currentDate = new Date();
        var fullDate = new Date(currentDate),
          mnth = ("0" + (currentDate.getMonth() + 1)).slice(-2),
          day = ("0" + currentDate.getDate()).slice(-2),
          hr = ("0" + currentDate.getHours()).slice(-2),
          min = ("0" + currentDate.getMinutes()).slice(-2),
          sec = ("0" + currentDate.getSeconds()).slice(-2);
        var dt = [fullDate.getFullYear(), mnth, day].join("");
        var time = [hr, min, sec].join("");
        let fileName = "daily_sellout_report_ca_" + dt + "_" + time + ".xlsx";
        let file = response.file;
        fetch(file)
          .then((res) => res.blob())
          .then((data) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            link.click();
          });
      } else if (Object.keys(response).includes("data")) {
        setDownloadMessage(response.data);
        setShowDownloadMessage(true);
      }
    });
  };

  const handleSortingData = async (obj) => {
    // setLoading(true)
    // setReportListing([])
    setSortField(obj.column);
    setSortOrder(obj.sortOrder);
    obj.column === "district_name" && setSortDistrictName(obj.sortOrder);
    obj.column === "person_in_charge" && setSortPerson(obj.sortOrder);
    obj.column === "parent_facility_name" &&
      setSortParentFacility(obj.sortOrder);
    obj.column === "delivered_facility_name" &&
      setSortDeliveryFacility(obj.sortOrder);
    obj.column === "accounting_month" && setSortAccountingMonth(obj.sortOrder);
    obj.column === "due_date" && setSortDueDate(obj.sortOrder);
    obj.column === "pack_l" && setSortPack(obj.sortOrder);
    obj.column === "package_quantities" &&
      setSortPackageQuantity(obj.sortOrder);
    obj.column === "sales_amount" && setSortSalesAmount(obj.sortOrder);
    obj.column === "sales_amount_by_wholesaler_purchase_price" &&
      setSortSalesAmountByWholesaler(obj.sortOrder);
    obj.column === "sales_amount_by_customer_purchase_price" &&
      setSortSalesAmountByCustomer(obj.sortOrder);
    obj.column === "customer_purchase_price_rate" &&
      setSortCustomerPurchasePrice(obj.sortOrder);
    obj.column === "wholesale_corporation_name" &&
      setSortWholesaleCorporation(obj.sortOrder);
    obj.column === "wholesale_branch_name" &&
      setSortWholesaleBranch(obj.sortOrder);
    obj.column === "slip_number" && setSortSlipNumber(obj.sortOrder);
    obj.column === "transaction_classification" &&
      setSortTransactionClassification(obj.sortOrder);
    obj.column === "child_facility_100_beds_classification" &&
      setSortHundredBeds(obj.sortOrder);
    obj.column === "parent_facility_evaluation_target_classification" &&
      setSortEvaluationTarget(obj.sortOrder);
    // let list = compareBySortedData(obj);
    // setReportListing(list)
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      target_date_from: targetPeriod === "0" ? "" : fromDate,
      target_date_to: targetPeriod === "0" ? "" : toDate,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      evaluation_target_classification: evaluationTargetId,
      preliminary_report: preliminaryReport,
      previous_business_day_only: previousBusinessDay,
      products_not_in_charge: productStatus,
      wholesaler_group:
        selectedWholesaler.length > 0 ? selectedWholesaler : "ALL",
      wholesaler_legal_entity:
        selectedEntity.length > 0 ? selectedEntity : "ALL",
      prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
      county: selectedCounty.length > 0 ? selectedCounty : "ALL",
      // company_copromotion_flg: copromotionStatus,
      userType: "CA",
      sort_field: obj.column,
      sort_order: obj.sortOrder,
    };
    await getDailySelloutCAReportList(body).then((response) => {
      setReportListing(response && response.data.data);
      setTotal(response && response.data.total_count);
      if (response.success === true && response.data.data.length > 0) {
        setReportListing(response && response.data.data);
        let count = response.data.total_count.split(",");
        setTotal(parseInt(count.join("")));
        setNoData(false);
        setLoading(false);
      } else if (
        (response.success === true && response.data.data.length === 0) ||
        response.success === false
      ) {
        setNoData(true);
        setLoading(false);
        setReportListing([]);
        setTotal();
      }
    });
  };

  const compareBySortedData = (obj) => {
    const sorted = reportListing.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  // const handleContainerOnBottom = async () => {
  //   let employeeList = [];
  //   details.map((emp) => employeeList.push(emp.wwid));
  //   let body = {
  //     employee_wwid:
  //       details && details.length > 0 ? employeeList : [personInCharge],
  //     employee_all_select: allSelected,
  //     target_date_from: targetPeriod === "0" ? "" : fromDate,
  //     target_date_to: targetPeriod === "0" ? "" : toDate,
  //     "100_bed": hundredFloorId,
  //     "200_bed": twoHundredFloorId,
  //     product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
  //     market_authorization_l:
  //       selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
  //     form_l: selectedForm.length > 0 ? selectedForm : "ALL",
  //     formulation_l:
  //       selectedFormulation.length > 0 ? selectedFormulation : "ALL",
  //     pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
  //     evaluation_target_classification: evaluationTargetId,
  //     preliminary_report: preliminaryReport,
  //     previous_business_day_only: previousBusinessDay,
  //     products_not_in_charge: productStatus,
  //     wholesaler_group:
  //       selectedWholesaler.length > 0 ? selectedWholesaler : "ALL",
  //     wholesaler_legal_entity:
  //       selectedEntity.length > 0 ? selectedEntity : "ALL",
  //     prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
  //     county: selectedCounty.length > 0 ? selectedCounty : "ALL",
  //     // company_copromotion_flg: copromotionStatus,
  //     limit: limit,
  //     userType: "CA",
  //     sort_field: sortField,
  //     sort_order: sortOrder,
  //   };
  //   if (reportListing.length <= total && total >= 30) {
  //     await getDailySelloutCAReportList(body).then((response) => {
  //       let list = [];
  //       list = reportListing.concat(response.data.data);
  //       setReportListing(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  
  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) !== -1;
  };

  const loadRecords = async () => {
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      target_date_from: targetPeriod === "0" ? "" : fromDate,
      target_date_to: targetPeriod === "0" ? "" : toDate,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      evaluation_target_classification: evaluationTargetId,
      preliminary_report: preliminaryReport,
      previous_business_day_only: previousBusinessDay,
      products_not_in_charge: productStatus,
      wholesaler_group:
        selectedWholesaler.length > 0 ? selectedWholesaler : "ALL",
      wholesaler_legal_entity:
        selectedEntity.length > 0 ? selectedEntity : "ALL",
      prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
      county: selectedCounty.length > 0 ? selectedCounty : "ALL",
      // company_copromotion_flg: copromotionStatus,
      limit: limit,
      userType: "CA",
      sort_field: sortField,
      sort_order: sortOrder,
    };
    if (reportListing.length < total) {
      setLazyLoading(true);
      await getDailySelloutCAReportList(body).then((response) => {
        let list = [];
        list = reportListing.concat(response.data.data);
        setLazyLoading(false);
        setReportListing(list);
      });
      setLimit(limit + LOAD_MORE_PAGE_SIZE);
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "salesreport";
    const filteredTexts2 = {};
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return  role === "CA" ||
  role === "Admin" ||
  role === "SalesManager" ||
  role === "BusinessOperation" ||
  role === "Wholesaler" ?  (
    <Home>
      <Breadcrumb finalText2={finalText2}  finalText={finalText} routes={routes} />
      {isScreenLoading && <Spinner animation="border" />}
      {maintenance === "1" && (
        <>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>{lang("SalesMenu.dailySelloutCA")}</Accordion.Header>
              <Accordion.Body>
                  <div className="user-details">
                    <div className="row">
                      <div className="col-md-4">
                        {lang("dailySellout.processingDate")}: {processingDate}
                      </div>
                      {/* <div className="col-md-4">
                    {lang("dailySellout.loginName")}: {loginName}
                  </div>
                  <div className="col-md-4">
                    {lang("dailySellout.organizationName")}: {organizationName}
                  </div> */}
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.personInCharge")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={personName}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <button
                              className="btn btn-primary"
                              onClick={(e) => changeRoute(e, "/searchMembers")}
                            >
                              {lang("dailySellout.selectPersonInCharge")}
                            </button>
                            <div className="custom-checkbox d-inline-block mr-3 ml-3 mb-2">
                              <input
                                type="checkbox"
                                id="status3"
                                name="status"
                                value={allSelected}
                                onChange={(e) => handleAllSelected(e)}
                                disabled={productStatus === true}
                              />
                              <label htmlFor="status3">
                                {lang("dailySellout.allSelection")}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <p className="annotations">
                            ★ {lang("annotations.personInChargeAnnotation")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="horizon-form">
                    <div className="custom-3 mt-3 mb-4">
                      <div className="custom-radio d-inline-block">
                        <input
                          type="radio"
                          id="order1"
                          name="sort-order"
                          value="preliminaryReport"
                          defaultChecked
                          onChange={(e) => handleDuration(e)}
                        />
                        <label htmlFor="order1">
                          {lang("dailySellout.preliminaryReport")}
                        </label>
                      </div>
                    </div>
                    <div className="custom-9 mt-3 mb-4">
                      <p className="annotations">
                        ★ {lang("annotations.targetPeriodAnnotation")}
                        <a
                          className="link"
                          onClick={() => window.open("/reception", "_blank")}
                        >
                          {lang("annotations.here")}
                        </a>{" "}
                        {lang("annotations.information")}
                      </p>
                    </div>
                    <div className="custom-3 mt-3 mb-4">
                      <div className="custom-radio d-inline-block">
                        <input
                          type="radio"
                          id="order2"
                          name="sort-order"
                          value="previousBusinessDay"
                          onChange={(e) => handleDuration(e)}
                        />
                        <label htmlFor="order2">
                          {lang("dailySellout.previousBusinessDay")}
                        </label>
                      </div>
                    </div>
                    <div className="custom-9 mt-3 mb-4"></div>

                    <div className="custom-3 mt-3 mb-4">
                      <div className="custom-radio d-inline-block">
                        <input
                          type="radio"
                          id="order3"
                          name="sort-order"
                          value="targetPeriod"
                          onChange={(e) => handleDuration(e)}
                        />
                        <label htmlFor="order3">
                          {lang("dailySellout.targetPeriod")}
                        </label>
                      </div>
                    </div>
                    <div className="custom-9 mt-3 mb-4">
                      {duration === "targetPeriod" && (
                        <div className="row">
                          <div className="col-lg-4 col-md-6">
                            <div className="form-group">
                              {/* <label>{lang("PersonMenu.from")}</label> */}
                              <DatePicker
                                value={fromDateDisplay}
                                minDate={startDate}
                                maxDate={toDateDisplay ? new Date(toDateDisplay) : endDate}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control"
                                onChange={(date) => handleFromYear(date)}
                                // showYearPicker
                                // dateFormat="yyyy"
                                // yearItemNumber={9}
                              />
                            </div>
                          </div>
                          <p style={{ margin: "10px 0" }}>~</p>
                          <div className="col-lg-4 col-md-6">
                            <div className="form-group">
                              {/* <label>{lang("PersonMenu.to")}</label> */}
                              <DatePicker
                                value={toDateDisplay}
                                minDate={fromDateDisplay ? new Date(fromDateDisplay) : startDate}
                                maxDate={endDate}
                                className="form-control"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                onChange={(date) => handleToYear(date)}
                                // showYearPicker
                                // dateFormat="yyyy"
                                // yearItemNumber={9}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.product")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.productL")}</label>
                            <Select
                              mode="multiple"
                              className="ant-select"
                              filterOption={filterOption}
                              options={productsList}
                              placeholder={
                                lang("dailySellout.productL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedProducts}
                              disabled={productStatus === true}
                              showSearch={
                                productsList && productsList.length > 0
                              }
                              onChange={handleProductChange}
                              onSelect={(e, value) =>
                                handleProductSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.marketAuthorizationL")}
                            </label>
                            <Select
                              className="ant-select"
                              filterOption={filterOption}
                              mode="multiple"
                              disabled={productStatus === true}
                              options={marketAuthList}
                              placeholder={
                                lang("dailySellout.marketAuthorizationL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedMarketAuth}
                              showSearch={
                                marketAuthList && marketAuthList.length > 0
                              }
                              loading={marketLoading}
                              onChange={handleMarketAuthorizationChange}
                              onSelect={(e, value) =>
                                handleMarketAuthSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.formL")}</label>
                            <Select
                              className="ant-select"
                              filterOption={filterOption}
                              mode="multiple"
                              options={formList}
                              placeholder={
                                lang("dailySellout.formL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedForm}
                              disabled={productStatus === true}
                              showSearch={formList && formList.length > 0}
                              loading={formLoading}
                              onChange={handleFormChange}
                              onSelect={(e, value) =>
                                handleFormSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.formulationL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={formulationList}
                              value={selectedFormulation}
                              placeholder={
                                lang("dailySellout.formulationL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              disabled={productStatus === true}
                              showSearch={formulationList && formulationList.length > 0}
                              loading={formulationLoading}
                              onChange={handleFormulationChange}
                              onSelect={(e, value) =>
                                handleFormulationSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.packL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={packagingList}
                              placeholder={
                                lang("dailySellout.packL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedPackaging}
                              disabled={productStatus === true}
                              showSearch={packagingList && packagingList.length > 0}
                              loading={packLoading}
                              onChange={handlePackagingChange}
                              onSelect={(e, value) =>
                                handlePackSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.productsNotInCharge")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="custom-checkbox d-inline-block mr-3 mt-3">
                        <input
                          type="checkbox"
                          id="status6"
                          name="status"
                          value="6"
                          onChange={(e) => handleProductStatus(e)}
                          disabled={
                            personName === "複数選択" || allSelected === 1
                          }
                        />
                        <label htmlFor="status6">
                          {lang("dailySellout.include")}
                        </label>
                      </div>
                      <p className="annotations">
                        ★ {lang("annotations.products")}
                      </p>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("dailySellout.facilityClassification")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.hundredBedClassification")}
                            </label>
                            <Select
                              className="ant-select"
                              options={hundredBedsList}
                              defaultValue={hundredBedsList[0]}
                              placeholder={lang(
                                "dailySellout.hundredBedClassification"
                              )}
                              onChange={handleHundredFloorChange}
                              labelInValue={true}
                              showSearch={true}
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.twoHundredBedClassification")}
                            </label>
                            <Select
                              className="ant-select"
                              options={twoHundredBedsList}
                              defaultValue={twoHundredBedsList[0]}
                              placeholder={lang(
                                "dailySellout.twoHundredBedClassification"
                              )}
                              onChange={handleTwoHundredFloorChange}
                              labelInValue={true}
                              showSearch={true}
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang(
                                "dailySellout.evaluationTargetClassification"
                              )}
                            </label>
                            <Select
                              className="ant-select"
                              options={evaluationTargetClassificationList}
                              defaultValue={
                                evaluationTargetClassificationList[0]
                              }
                              placeholder={lang(
                                "dailySellout.evaluationTargetClassification"
                              )}
                              onChange={handleEvaluationTargetChange}
                              labelInValue={true}
                              showSearch={true}
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("dailySellout.wholesalerOrganization")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesalerGroup")}
                            </label>
                            <Select
                              className="ant-select"
                              options={wholesalerGroupList}
                              mode="multiple"
                              value={selectedWholesaler}
                              placeholder={lang("dailySellout.wholesalerGroup")}
                              onChange={handleWholesalerGroupChange}
                              onSelect={(e, value) =>
                                handleWholeSalerGroupSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesaleCorporation")}
                            </label>
                            <Select
                              className="ant-select"
                              options={legalEntityList}
                              mode="multiple"
                              value={selectedEntity}
                              loading={legalEntityLoading}
                              placeholder={lang(
                                "dailySellout.wholesaleCorporation"
                              )}
                              disabled={
                                selectedWholesaler.length > 0 ? false : true
                              }
                              onChange={handleLegalEntityChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.area")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang(
                                "parentChildFacilityMaintenance.prefecture"
                              )}
                            </label>
                            <Select
                              className="ant-select"
                              options={prefectureList}
                              mode="multiple"
                              placeholder={lang(
                                "parentChildFacilityMaintenance.prefecture"
                              )}
                              onChange={handlePrefectureChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>{lang("dailySellout.cityAndCounty")}</label>
                            <Select
                              className="ant-select"
                              options={countyList}
                              mode="multiple"
                              value={selectedCounty}
                              loading={cityLoading}
                              placeholder={lang("dailySellout.cityAndCounty")}
                              disabled={
                                selectedPrefecture.length > 0 ? false : true
                              }
                              onChange={handleCountyChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("dailySellout.copromotionFlag")}</label>
                </div>
                <div className="custom-9">
                  <div className="custom-checkbox d-inline-block mr-3 mt-3">
                    <input
                      type="checkbox"
                      id="flag"
                      name="status"
                      value="6"
                      onChange={(e) => handleCopromotionStatus(e)}
                    />
                    <label htmlFor="flag">{lang("dailySellout.include")}</label>
                  </div>
                </div>
              </div> */}
                  <div className="mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={getDailySelloutReportCA}
                      disabled={loading}
                    >
                      {lang("dailySellout.display")}
                    </button>
                  </div>
                </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          {reportListing.length > 0 && loading === false && (
            <div className="card">
              <div className="card-body">
                <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {reportListing.length} / {total}
                </p>
                <div
                  // ref={containerRef}
                  // onBottom={handleContainerOnBottom}
                  className="table-responsive mb-0 hover-table max-height"
                >
                  <table className="table" aria-describedby="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "district_name",
                              sortOrder:
                                sortDistrictName === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.districtName")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "person_in_charge",
                              sortOrder: sortPerson === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.personInCharge")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "parent_facility_name",
                              sortOrder:
                                sortParentFacility === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.parentFacilityName")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "delivered_facility_name",
                              sortOrder:
                                sortDeliveryFacility === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.deliveredFacilityName")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "accounting_month",
                              sortOrder:
                                sortAccountingMonth === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.accountingMonth")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "due_date",
                              sortOrder:
                                sortDueDate === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.dueDate")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "pack_l",
                              sortOrder: sortPack === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.packL")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "package_quantities",
                              sortOrder:
                                sortPackageQuantity === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.packageQuantities")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "sales_amount",
                              sortOrder:
                                sortSalesAmount === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.salesAmount")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column:
                                "sales_amount_by_wholesaler_purchase_price",
                              sortOrder:
                                sortSalesAmountByWholesaler === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.salesAmountByWholesaler")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "sales_amount_by_customer_purchase_price",
                              sortOrder:
                                sortSalesAmountByCustomer === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.salesAmountByCustomer")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "customer_purchase_price_rate",
                              sortOrder:
                                sortCustomerPurchasePrice === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.customerPurchasePriceRate")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "wholesale_corporation_name",
                              sortOrder:
                                sortWholesaleCorporation === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.wholesaleCorporationName")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "wholesale_branch_name",
                              sortOrder:
                                sortWholesaleBranch === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.wholesaleBranch")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "slip_number",
                              sortOrder:
                                sortSlipNumber === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.slipNumber")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "transaction_classification",
                              sortOrder:
                                sortTransactionClassification === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.transactionClassification")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "child_facility_100_beds_classification",
                              sortOrder:
                                sortHundredBeds === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang(
                              "dailySellout.childFacilityHundredFloorDivision"
                            )}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column:
                                "parent_facility_evaluation_target_classification",
                              sortOrder:
                                sortEvaluationTarget === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang(
                              "dailySellout.parentFacilityEvaluationClassification"
                            )}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportListing &&
                        reportListing.length > 0 &&
                        reportListing.map((report, index) => {
                          return (
                            <tr key={index}>
                              <td>{report.district_name}</td>
                              <td>{report.person_in_charge}</td>
                              <td>{report.parent_facility_name}</td>
                              <td>{report.delivered_facility_name}</td>
                              <td>{report.accounting_month}</td>
                              <td>{report.due_date}</td>
                              <td>{report.pack_l}</td>
                              <td>{report.package_quantities}</td>
                              <td>{report.sales_amount}</td>
                              <td>
                                {
                                  report.sales_amount_by_wholesaler_purchase_price
                                }
                              </td>
                              <td>
                                {report.sales_amount_by_customer_purchase_price}
                              </td>
                              <td>{report.customer_purchase_price_rate}</td>
                              <td>{report.wholesale_corporation_name}</td>
                              <td>{report.wholesale_branch_name}</td>
                              <td>{report.slip_number}</td>
                              <td>{report.transaction_classification}</td>
                              <td>
                                {report.child_facility_100_beds_classification}
                              </td>
                              <td>
                                {
                                  report.parent_facility_evaluation_target_classification
                                }
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="filter-actions mt-4 mb-4">
                  {excelLoading && <Spinner animation="border" />}
                  {lazyLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={handleExcelDownload}
                    disabled={excelLoading}
                  >
                    {lang("dailySellout.excelDownload")}
                  </button>
                  {total > 0 && (
                    <button
                      className="btn btn-primary"
                      onClick={loadRecords}
                      disabled={(lazyLoading || reportListing.length >= total)}
                      >
                      {lang("Buttons.loadMore")}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {loading === true && <Spinner animation="border" />}
          {noData && <div className="noData">No data found</div>}
          <Modal
            size="md"
            className="withdraw-modal"
            show={showUserMessage}
            onHide={handleCloseUserMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <p>{lang("dailySellout.allSelectionConfirmation")}</p>
                <p>{lang("dailySellout.run")}</p>
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleDailySelloutReportCA}
                >
                  {lang("Buttons.ok")}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseUserMessage}
                >
                  {lang("Buttons.cancel")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            size="md"
            className="withdraw-modal"
            show={showDownloadMessage}
            onHide={handleCloseDownloadMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">{downloadMessage}</div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseDownloadMessage}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
      {maintenance === "0" && <SalesMaintenance />}
    </Home>
  ) : (
    <Home>
      <p>You don't have required permission to view this page</p>
    </Home>
  );
}

export default DailySelloutCA;
